import type { SessionItem } from "@memorang/types/src/session/new-session";

/* -----------------Container--------------- */
import StudySessionItemContainer from "../../containers/StudySessionItemContainer";

import { useDevice } from "@hooks/useDevice";
/* -----------------Child components--------------- */
import { Box } from "@memorang/ui";
import { useLocalSearchParams } from "expo-router";
import { sessionMaxWidth } from "../../constants";
import { getHasParentStem, isAiSimulationItem } from "../../helpers";
import useSessionStore from "../../hooks/useSessionStore";

interface Props {
	items: SessionItem[];
	toggleShowReadMore?: () => void;
}

const SessionListDesktop = ({ items, toggleShowReadMore }: Props) => {
	const { isMobile } = useDevice();
	const localSearchParams = useLocalSearchParams<{
		index: string;
		id: string;
	}>();

	const isSummativeTest = useSessionStore((state) => state.isSummativeTest);
	const isProethicaTest = useSessionStore(
		(state) => state.proethicaTestKind != null,
	);
	const index = localSearchParams.index
		? Number.parseInt(localSearchParams.index)
		: 0;
	const sessionId = localSearchParams?.id;
	const currentItem = index ? items[index - 1] : items[0];
	const { stimulus } = currentItem;

	const parentStem = stimulus?.content.passage?.paragraphs
		?.map((paragraph) => paragraph.text)
		.join(" ");

	const parentTitle = stimulus?.content.passage?.title;
	const hasParentStem = getHasParentStem(parentStem, parentTitle, isMobile);

	const isWide = hasParentStem || isAiSimulationItem(currentItem);

	return (
		<Box
			style={{
				width: "100%",
				height: "100%",
				// Pre/post tests left-align the question column under the toolbar
				// (matching the diagnostic-test layout) instead of centering it in a
				// wide empty area.
				alignSelf: isProethicaTest ? "flex-start" : undefined,
			}}
			maxWidth={
				isSummativeTest && !isProethicaTest
					? sessionMaxWidth.summative
					: isWide
						? 1300
						: sessionMaxWidth.formative
			}
			paddingHorizontal={isSummativeTest ? 16 : 0}
		>
			<StudySessionItemContainer
				item={currentItem}
				toggleShowReadMore={toggleShowReadMore}
				sessionId={sessionId ? Number.parseInt(sessionId) : undefined}
			/>
		</Box>
	);
};
export default SessionListDesktop;
